import { Marker } from "react-map-gl/mapbox"

import { PinIcon } from "@l2r-front/l2r-icons"
import { useTheme } from "@l2r-front/l2r-ui"

export function GpsLocationPinMarker(props) {

    const { location } = props
    const theme = useTheme()

    return <Marker longitude={location[0]} latitude={location[1]} anchor="bottom" >
        <PinIcon width={50} height={50} style={{ color: theme.palette["error"].main }} />
    </Marker>
}